require("./app_bootstrap");
require("./components/currency-field");
require("./components/dialogs");
require("./components/tabbed-content");
require("./pages/agent-dashboard");
require("./components/countdown");
require("./components/raqform");
require("./components/tabbed-content");
require("./components/youtube-embed");

import Alpine from "alpinejs";

window.Alpine = Alpine;

Alpine.start();
